<template>
  <div class="c-content-template">
    <div class="c-content-template__container">
      <div class="c-content-template__content">
        <div class="c-content-template__row">
          <div
            class="c-content-template__cell"
            v-for="content in config.content"
            :key="content.index"
          >
            <h4 v-if="content.title" class="c-content-template__title">
              {{ content.title }}
            </h4>
            <div
              v-if="content.description"
              class="c-rte c-content-template__description"
              v-html="content.description"
            ></div>
            <a
              v-if="content.link"
              class="c-button c-button--brand c-button--bg-color-brand-seven c-content-template__action"
              :href="content.link.url"
            >
              {{ content.link.text }}
            </a>
          </div>
        </div>
        <div class="c-content-template__row">
          <div
            v-if="config.footerContent"
            class="c-rte c-content-template__description"
            v-html="config.footerContent"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ContentTemplate",
    props: {
      config: {
        type: Object,
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/contact-us/_vue/ContentTemplate.vue